<div class="led"><div class="body nm" :class="{on: value}"></div></div>